
import './assets/MediaQueries.css'
import React from 'react';
import Main from './Main.jsx';

const App = () => {
 return (
      <div className="App">
        <Main />
      </div>
  );
}
export default App;
